import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { auth, users } from "data/actions";

import RaisedButton from 'material-ui/RaisedButton';
import Subheader from 'material-ui/Subheader';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { Page, PageSection, PageBlock, RightDrawer } from 'components/Page';

import Row from 'components/Form/Row';
import Field from 'components/Form/Field';

class UserDetails extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  state = { };

  handleCancel(id) {
    this.context.router.history.push("/");
  }


  componentWillMount() {
    this.props.actions.fetchUser(this.props.params.id);
  }

  handleFormSubmit(event) {
    

    // this.props.actions.updateUserInfo(this.props.params.id, this.props.user.info, {
    //   displayName: this.refs.name.state.value,
    //   email: this.refs.email.state.value,
    // });

    var userInfo = {...this.props.user.info, 
      email: this.refs.email.state.value,
      phone: this.refs.phone.state.value,  
    }
    this.props.actions.saveUserInfo(userInfo);

  }

  render() {
    if (!this.props.user || !this.props.user.info) return null;

    var {email, phone} = this.props.user.info;    

    var verification = (<Row><RaisedButton secondary={true} label="Skicka verifieringsmail!" /> &nbsp; <RaisedButton secondary={true} label="Ändra lösenord" /> </Row>)

    return [
      <RightDrawer key="right">
        <PageBlock label="Användare">
        
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <div onSubmit={this.handleFormSubmit.bind(this)} className="form-inline">
          
          <PageSection label="Inloggning">
            <Row>
              <Field floatingLabelText="E-post" ref="email" value={email} />
            </Row>
            <Row>
              <Field floatingLabelText="Telefonnummer" ref="phone" value={phone} />
            </Row>
            <Row>
              <SelectField floatingLabelText="Roll"  >
                <MenuItem value="st" primaryText="Systemadministratör" />
                <MenuItem value="st" primaryText="Kontoadministratör" />
                <MenuItem value="procent" primaryText="Beställare" />
                <MenuItem value="sek" primaryText="Bokare" />
              </SelectField>
            </Row>
            {verification}
          </PageSection>
          <PageSection label="Kontaktuppgifter">
            <Row>
              <Field floatingLabelText="Namn" ref="name" value="" />
            </Row>
            <Row>
              <Field floatingLabelText="Företag" ref="account" value="" />
            </Row>


          </PageSection>
          
          <PageSection label="">
            <Row styleName="padded">
              <RaisedButton onTouchTap={this.handleFormSubmit.bind(this)}  primary={true}  label="Spara" />
              <RaisedButton onTouchTap={this.handleCancel.bind(this)} label="Stäng" />
            </Row>
          </PageSection>
        </div>
      </Page>
    ]
  }
}


function mapStateToProps(state, ownProps) {
  return {
    user: state.users.details ,
    pending: !state.users.details 
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...auth, ...users },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(UserDetails)

  



// WEBPACK FOOTER //
// ./src/pages/admin/users/UserDetails.jsx